import { FETCH_NEXT_STEPS_MP_CARD_FAILURE, FETCH_NEXT_STEPS_MP_CARD_REQUEST, FETCH_NEXT_STEPS_MP_CARD_SUCCESS } from "../../actions/meetingPrep/nextStepsMpCardActions";

  const initialState = {
    nextStepsMpCardLoading: false,
    nextStepsMpCardData: [],
    nextStepsMpCardError: null,
  };
  
  const nextStepsMpCardReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_NEXT_STEPS_MP_CARD_REQUEST:
        return { ...state, nextStepsMpCardLoading: true , payload: action.payload};
      case FETCH_NEXT_STEPS_MP_CARD_SUCCESS:
        return { ...state, nextStepsMpCardLoading: false, nextStepsMpCardData: action.payload };
      case FETCH_NEXT_STEPS_MP_CARD_FAILURE:
        return { ...state, nextStepsMpCardLoading: false, nextStepsMpCardError: action.payload };       
      default:
        return state;
    }
  };
  
  export default nextStepsMpCardReducer;
  